import React from "react";
import Layout from "../../components/Layout";
import HeroSection from "../../components/HeroSection/HeroSection";
import { useTranslation } from "react-i18next";
import ImageGallery from "../../components/gallery/ImageGallery/ImageGallery";
import { Helmet } from "react-helmet-async";

/*----- Hero Images -----*/
import heroImage1 from "../../assets/images/great-hall/greatHall7.jpg";
import heroImage2 from "../../assets/images/crystal-hall/crystalHall7.jpg";
import heroImage3 from "../../assets/images/small-hall/smallHall7.jpg";
import heroImage4 from "../../assets/images/playroom/playroom7.jpg";
import heroImage5 from "../../assets/images/catering/catering8.jpg";

export default function Gallery() {
  const { t } = useTranslation(["gallery", "links"]);
  return (
    <Layout>
      <Helmet>
        <title>Naša Galerija</title>
        <meta
          name="description"
          content={
            "Istražite trenutke zabeležene u restoranu Vidovdan, od živopisnih proslava do elegantnih gastronomskih doživljaja. Naša galerija prikazuje ambijent, ljude i uspomene koje svaku posetu čine posebnom."
          }
        />
        <link rel="canonical" href={"https://vidovdanrestoran.rs/gallery"} />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content={"Naša Vidovdan"} />
        <meta
          property="og:description"
          content={
            "Istražite trenutke zabeležene u restoranu Vidovdan, od živopisnih proslava do elegantnih gastronomskih doživljaja. Naša galerija prikazuje ambijent, ljude i uspomene koje svaku posetu čine posebnom."
          }
        />
        <meta property="og:image" content={heroImage3} />
        <meta
          property="og:url"
          content={"https://vidovdanrestoran.rs/gallery"}
        />
        <meta property="og:site_name" content="Vidovdan" />
        <meta property="og:locale" content="sr_RS" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={"Naša Galerija"} />
        <meta
          name="twitter:description"
          content={
            "Istražite trenutke zabeležene u restoranu Vidovdan, od živopisnih proslava do elegantnih gastronomskih doživljaja. Naša galerija prikazuje ambijent, ljude i uspomene koje svaku posetu čine posebnom."
          }
        />
        <meta name="twitter:image" content={heroImage3} />
      </Helmet>
      <HeroSection
        images={[heroImage1, heroImage2, heroImage3, heroImage4, heroImage5]}
        title={t("gallery_hero_title")}
        subTitle={t("gallery_hero_subtitle")}
        description={t("gallery_hero_description")}
      />
      <ImageGallery t={t} />
    </Layout>
  );
}
